import { render } from "./DettaglioOrdine.vue?vue&type=template&id=1cd6cdce&scoped=true"
import script from "./DettaglioOrdine.vue?vue&type=script&lang=js"
export * from "./DettaglioOrdine.vue?vue&type=script&lang=js"

import "./DettaglioOrdine.vue?vue&type=style&index=0&id=1cd6cdce&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd6cdce"]])

export default __exports__